import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { NavLink } from "react-router-dom";

import axios from "axios";
import { toast } from "react-toastify";

const initialValue = {
  title: "",
  image: "",
  articleType: "",
  description: "",
  markdown: "",
};

const EditBlog = () => {
  const [editBlog, setEditBlog] = useState(initialValue);
  const [blogimage, setBlogImage] = useState();

  const { id } = useParams();

  let navigate = useNavigate();

  let name, value;
  const dataInputFn = (event) => {
    name = event.target.name;
    value = event.target.value;
    setEditBlog({ ...editBlog, [name]: value });
  };

  const uploadArticleImage = async () => {
    try {
      const data = new FormData();
      data.append("file", blogimage);
      data.append("upload_preset", "blogify-web");
      data.append("cloud_name", "ninja-cloud");

      const res = await axios.post(
        "https://api.cloudinary.com/v1_1/ninja-cloud/image/upload",
        data
      );

      if (res.status === 200) {
        const blogUrl = res.data.secure_url;
        setEditBlog({ ...editBlog, image: blogUrl });
      }
    } catch (error) {}
  };

  //load data on edit page
  const loadBlogDetails = async () => {
    try {
      const response = await axios.get(
        `https://blogappserver-8sw1.onrender.com/articles/${id}`
      );
      setEditBlog(response.data);
    } catch (error) {}
  };

  const editBlogDetails = async (e) => {
    e.preventDefault();
    try {
      // const config = {
      //   withCredentials: true
      // }
      const res = await axios.put(
        `https://blogappserver-8sw1.onrender.com/articles/edit/${id}`,
        editBlog,
        {
          withCredentials: true,
        }
      );
      navigate(`/articles/${id}`);

      if (res.status !== 200) {
        throw new Error(res.error);
      }
      toast("successfully updated..!!", { type: "success" });
    } catch (error) {
      toast("try it again..!!", { type: "error" });
    }
  };

  useEffect(() => {
    loadBlogDetails();

    if (blogimage) {
      uploadArticleImage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blogimage]);

  return (
    <>
      <form action={`/articles/${id}`} encType="multipart/form-data">
        <div className="blog-d">
          <h2 className="text-center blog-header-rm text-uppercase">
            Edit Blog
          </h2>

          <div className="form-group mb-2">
            <label htmlFor="title">Title
              <span style={{color: "red"}}>[Exceed up to 30 characters]</span>
            </label>
            <input
              required
              type="text"
              name="title"
              id="title"
              value={editBlog.title}
              onChange={dataInputFn}
              maxLength={30}
              className="form-control"
            />
          </div>

          <div className="form-group mb-2">
            <label htmlFor="type">Article Type</label>
            <select name="articleType" id="type" onChange={dataInputFn}>
              <option className="text-muted">Type Of Blog</option>
              <option>Tech</option>
              <option>Sport</option>
              <option>Education</option>
              <option>Life Style</option>
              <option>Food</option>
              <option>Travel</option>
              <option>Marketing</option>
              <option>Business</option>
              <option>Environment</option>
              <option>DIY</option>
            </select>
          </div>

          <div className="form-group mb-2">
            <label htmlFor="image">Image</label>
            <input
              required
              type="file"
              name="image"
              id="image"
              onChange={(e) => setBlogImage(e.target.files[0])}
              className="form-control"
            />
          </div>

          <div className="form-group mb-2">
            <label htmlFor="description">Description
              <span style={{color: "red"}}>[in one sentence..]</span>
            </label>
            <textarea
              required
              name="description"
              id="description"
              value={editBlog.description}
              onChange={dataInputFn}
              maxLength={100}
              className="form-control"
            ></textarea>
          </div>

          <div className="form-group mb-4">
            <label htmlFor="markdown">Markdown Editor</label>
            <textarea
              required
              name="markdown"
              id="markdown"
              rows="5"
              value={editBlog.markdown}
              onChange={dataInputFn}
              className="form-control"
            ></textarea>
          </div>

          <div className="text-center">
            <NavLink
              to="/articles"
              className="btn btn-secondary mx-3 px-3"
            >
              Cancel
            </NavLink>
            <button
              onClick={editBlogDetails}
              className="btn btn-primary mx-3 px-4"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default EditBlog;

/* <form action={`/articles/edit/${id}?_method=PUT`} method="POST" encType="multipart/form-data">
    <PostArticle />
</form> */
